import React from 'react';
import emailjs from 'emailjs-com';

import { TextField } from '@material-ui/core';
const Contact = ({ size }) => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_p59ustz', 'template_xagjhug', e.target, 'user_pHPHe8BhQga6YSkubEUQZ').then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  }
  return (
    <div>
      <form id='form' onSubmit={sendEmail} className='mt-4 text-lg mx-auto max-w-xs md:max-w-lg space-y-4'>
        {/* name */}
        <label htmlFor='name' hidden>
          שם
        </label>
        <TextField label='שם' name='from_Name' type='text' size={size} variant='outlined' id='name' fullWidth={true} required />
        <br />

        {/* E-Mail */}
        <label htmlFor='email' hidden>
          אימייל
        </label>
        <TextField label='אימייל' name='Sender_Email' size={size} variant='outlined' id='email' type='text' fullWidth={true} required />
        <br />

        {/* Phone Number */}
        <label htmlFor='phone' hidden>
          מספר טלפון
        </label>
        <TextField label='מספר טלפון' name='Sender_Phone' size={size} variant='outlined' id='phone' fullWidth={true} required />
        <br />

        {/* Conpany Name */}
        <label htmlFor='Sender_Company' hidden>
          שם החברה
        </label>
        <TextField label='שם החברה' name='Sender_Company' size={size} variant='outlined' id='Sender_Company' type='text' fullWidth={true} required />
        <br />

        {/* The Message */}
        <label htmlFor='message' hidden>
          ההודעה
        </label>
        <TextField label='ההודעה' name='message' size={size} type='text' variant='outlined' id='message' autoComplete={'false'} multiline={true} rows={5} fullWidth={true} required />
        <br />
        <br />

        <button
          type='submit'
          id='button'
          className={(size === 'small' ? `px-4 py-1 text-2xl ` : `px-5 py-2 text-2xl`) + ' shadow rounded-full bg-gradient-to-br from-green-200 to-blue-200 font-secular btnSend'}
        >
          שלח
        </button>
      </form>
    </div>
  );
};

export default Contact;
